
export const isProduction = () => process.env.NODE_ENV === 'production';

export const getBackendUrl = () => {
  return isProduction()
    ? process.env.REACT_APP_BACKEND_URL_PROD
    : process.env.REACT_APP_BACKEND_URL_DEV;
};
